.appShell {
	width: min(100%, 1180px);
	margin: 0 auto;
	padding: 10px 12px 80px;
	/* extra bottom padding for bottom nav */
	box-sizing: border-box;
}

.subtitle {
	margin: 10px 0 0;
	max-width: 100%;
}

.headerActions {
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: stretch;
}

.primaryButton,
.secondaryButton {
	border: 1px solid transparent;
	border-radius: 999px;
	padding: 10px 16px;
	min-height: 40px;
	cursor: pointer;
	transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
	font: inherit;
	font-size: 0.9rem;
	touch-action: manipulation;
}

.primaryButton {
	background: var(--accent);
	color: white;
}

.secondaryButton {
	background: transparent;
	color: var(--text-h);
	border-color: var(--border);
}

.primaryButton:hover,
.secondaryButton:hover {
	transform: translateY(-1px);
	box-shadow: var(--shadow);
}

button:focus-visible,
input:focus-visible {
	outline: 2px solid var(--accent);
	outline-offset: 4px;
}

.searchPanel,
.mainPanel,
.settingsPanel {
	margin-top: 14px;
}

.settingsHeader {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 10px;
}

.globalSearchButton {
	display: block;
	margin: 12px auto 0;
	padding: 7px 12px;
	min-height: 34px;
	background: transparent;
	color: var(--text);
	border: 1px solid var(--border);
	border-radius: 999px;
	font: inherit;
	font-size: 0.82rem;
	cursor: pointer;
}

.globalSearchButton:hover {
	border-color: var(--accent);
	color: var(--accent);
}

.backupReminder {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 4px;
	margin-bottom: 14px;
	padding: 12px 16px;
	border: 1px solid color-mix(in srgb, var(--accent) 45%, var(--border));
	border-radius: 14px;
	background: color-mix(in srgb, var(--accent) 10%, var(--code-bg));
}

.backupReminderHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.backupReminderActions {
	display: flex;
	align-items: center;
	gap: 14px;
}

.backupReminderLink {
	border: 0;
	padding: 0;
	background: transparent;
	color: var(--accent);
	font: inherit;
	font-weight: 700;
	cursor: pointer;
}

.backupReminderDismiss {
	border: 0;
	padding: 0 2px;
	background: transparent;
	color: var(--text);
	font-size: 24px;
	line-height: 1;
	cursor: pointer;
}

.backupReminderDismiss:hover { color: var(--text-h); }

.searchField {
	display: grid;
	gap: 10px;
	margin-bottom: 22px;
	grid-template-columns: minmax(0, 1fr) 180px;
}

.searchField label { grid-column: 1 / -1; }

.searchField label {
	font-weight: 600;
}

.searchField input {
	width: 100%;
	box-sizing: border-box;
	padding: 8px 12px;
	min-height: 36px;
	border-radius: 999px;
	border: 1px solid var(--border);
	background: var(--code-bg);
	min-height: 48px;
}

.title {
	margin: 0;
	font-size: 1.05rem;
	line-height: 1.2;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.searchResults {
	display: grid;
	gap: 18px;
}

.searchSection {
	display: grid;
	gap: 12px;
}

.searchSectionTitle {
	margin: 0;
	font-size: 1.05rem;
	color: var(--text-h);
}

.tabBar {
	display: grid;
	gap: 10px;
	margin-bottom: 14px;
}

.tabButton {
	width: 100%;
	border: 1px solid var(--border);
	border-radius: 16px;
	background: transparent;
	color: var(--text-h);
	padding: 16px 18px;
	min-height: 52px;
	text-align: left;
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	touch-action: manipulation;
}

.tabButtonActive {
	background: linear-gradient(90deg, rgba(170, 59, 255, 0.08), rgba(100, 74, 255, 0.04));
	border-color: var(--accent-border);
	color: var(--accent);
}

.tabContent {
	min-height: 320px;
}

.showList,
.timelineList {
	list-style: none;
	padding: 0;
	margin: 0;
}

.showListButton h3,
.timelineCard h3,
.showCardTitle {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
}

.showListButton,
.timelineCard {
	padding: 20px;
	background: rgba(255, 255, 255, 0.85);
	box-shadow: var(--shadow);
}

.showListItem {
	display: grid;
	gap: 14px;
}

.showListItem h3,
.timelineCard h3 {
	margin: 0 0 8px;
}

.showMeta {
	display: flex;
	flex-direction: row;
	gap: 8px;
	text-align: left;
	min-width: 0;
}

.showCardMeta {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	text-align: left;
	min-width: 0;
}

.showGrid {
	display: grid;
	gap: 12px;
	grid-template-columns: repeat(auto-fit, minmax(112px, 190px));
	justify-content: center;
}

.searchField .globalSearchInputWrap {
	min-width: 0;
}

@media (max-width: 520px) {
	.searchField { grid-template-columns: minmax(0, 1fr) 132px; }
	.searchField label { grid-column: auto; }
	.searchField label { grid-column: 1 / -1; }
	.searchField .genreDropdown { width: 132px; }
}

.genreDropdown { position: relative; width: 100%; min-width: 0; }
.genreButton { width: 100%; min-height: 48px; height: 48px; padding: 0 14px; display: flex; align-items: center; justify-content: space-between; gap: 10px; box-sizing: border-box; border: 1px solid var(--border); border-radius: 14px; background: var(--code-bg); color: var(--text-h); font: inherit; cursor: pointer; white-space: nowrap; }
.genreButton:disabled { opacity: .7; cursor: wait; }
.genreButtonActive { background: var(--accent); border-color: var(--accent); color: white; }
.searchField .genreButton { border-radius: 999px; background: transparent; padding: 0 16px; }
.searchField .genreButton.genreButtonActive { background: var(--accent); border-color: var(--accent); color: white; }
.genreChevron { width: 7px; height: 7px; flex: 0 0 7px; border-right: 2px solid currentColor; border-bottom: 2px solid currentColor; transform: rotate(45deg) translateY(-2px); }
.genreMenu { position: absolute; z-index: 20; top: calc(100% + 6px); left: 0; right: auto; width: 230px; max-width: calc(100vw - 32px); max-height: 260px; overflow-y: auto; overflow-x: hidden; padding: 6px; box-sizing: border-box; border: 1px solid var(--border); border-radius: 12px; background: var(--bg); box-shadow: var(--shadow); }
.genreOption { display: block; width: 100%; padding: 9px 10px; border: 0; border-radius: 8px; background: transparent; color: var(--text-h); font: inherit; text-align: left; cursor: pointer; }
.genreOption { white-space: nowrap; }
.genreOption { overflow: hidden; text-overflow: ellipsis; }
.genreOption:hover, .genreOption:focus-visible { background: var(--accent-bg); color: var(--accent); outline: none; }

.globalSearchInputWrap { position: relative; }
.globalSearchInputWrap input { padding-right: 42px; }
.globalSearchClear { position: absolute; top: 50%; right: 12px; transform: translateY(-50%); border: 0; padding: 4px; background: transparent; color: var(--text); cursor: pointer; line-height: 1; }

.genreButton:focus-visible {
	outline: 2px solid var(--accent);
	outline-offset: 1px;
	border-color: var(--accent);
}

.sortControls .genreDropdown {
	width: 120px !important;
	max-width: 120px !important;
	flex: 0 0 120px !important;
}

.sortControls .genreDropdown .genreButton {
	all: unset;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 120px !important;
	min-width: 120px !important;
	max-width: 120px !important;
	height: 40px !important;
	min-height: 40px !important;
	padding: 0 12px !important;
	font-size: 0.9rem !important;
	line-height: 1 !important;
	box-sizing: border-box;
	border: 1px solid var(--border);
	border-radius: 999px;
	background: transparent;
	color: var(--text-h);
	cursor: pointer;
}
.sortControls .genreDropdown .genreButton.genreButtonActive {
	background: var(--accent);
	border-color: var(--accent);
	color: white;
}

.sortControls .genreMenu { width: 230px; }

.librarySearchWrap .genreButton {
	min-height: 36px;
	padding: 8px 12px;
	font-size: 0.85rem;
}

.showGridCompact {
	display: grid;
	gap: 12px;
	grid-template-columns: repeat(auto-fit, minmax(120px, 190px));
	justify-content: center;
}

.unwatchedGrid {
	display: grid;
	gap: 8px;
	grid-template-columns: repeat(3, 1fr);
	width: 100%;
	box-sizing: border-box;
}

@media (max-width: 360px) {
	.unwatchedGrid {
		grid-template-columns: repeat(2, 1fr);
	}
}

/* Fixed height on the grid item — every card identical, no inheritance needed */
.unwatchedGrid .showCardButton {
	height: auto;
	min-height: 250px;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
}

.unwatchedGrid .showCard {
	height: 100%;
	min-height: 0;
	/* override the 160px base min-height */
	display: flex;
	flex-direction: column;
	gap: 0;
}

.unwatchedGrid .showCardImageWrap {
	height: 170px;
	aspect-ratio: auto;
	flex-shrink: 0;
	max-height: 170px;
	border: 1px solid var(--border);
	border-radius: 12px;
}

.unwatchedGrid .showCardBody {
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 6px 4px 6px;
	gap: 4px;
	overflow: hidden;
	min-width: 0;
}

.unwatchedGrid .showCardTitle {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 2.4em;
	font-size: 0.9rem;
	line-height: 1.2;
	flex-shrink: 0;
}

.unwatchedGrid .showCardBody>span {
	display: none;
	/* episode title now lives in the action slot */
}

.unwatchedGrid .showCardMeta {
	flex-shrink: 0;
	margin-top: auto;
	width: 100%;
}

/* Footer groups episode title + badge with no gap between them */
.unwatchedCardFooter {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-direction: column;
	margin-top: auto;
	gap: 3px;
	width: 100%;
	min-width: 0;
}

.unwatchedEpTitle {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 0.72rem;
	line-height: 1.35;
	padding-bottom: 2px;
	color: var(--text);
	width: 100%;
	text-align: center;
	display: block;
}

.unwatchedGrid .badge {
	padding: 3px 8px;
	font-size: 0.8rem;
	width: auto;
	max-width: 100%;
	box-sizing: border-box;
}

.timelineList {
	list-style: none;
	margin: 0;
	padding: 0;
	display: grid;
	gap: 16px;
}

.timelineItem {
	width: 100%;
}

@media (max-width: 520px) {
	.showGrid {
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
	}

	.showGridCompact {
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
	}
}

.watchingToolbar {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	margin-bottom: 14px;
	position: relative;
	z-index: 40;
}

.librarySearchWrap {
	display: flex;
	align-items: center;
	gap: 6px;
	position: relative;
	max-width: 100%;
}

.librarySearchInput {
	padding: 8px 30px 8px 12px;
	border-radius: 999px;
	border: 1px solid var(--border);
	background: var(--code-bg);
	color: var(--text-h);
	font: inherit;
	font-size: 0.85rem;
	min-height: 36px;
	box-sizing: border-box;
	width: 190px;
	min-height: 36px;
}

.unwatchedGrid .showCardImage {
	object-fit: cover;
	background: var(--code-bg);
}

.librarySearchInput:focus {
	border-color: var(--accent);
}

.searchInputWrap { position: relative; flex: 0 0 190px; }
.librarySearchWrap > .librarySearchClear { display: none; }

.librarySearchInput:focus-visible {
	outline: none;
}

@media (max-width: 600px) {
	.watchingToolbar {
		display: block;
		align-items: stretch;
		min-width: 0;
		max-width: 100%;
	}

	.watchingToolbar .sortControls {
		flex-wrap: nowrap;
		overflow-x: auto;
		min-width: 0;
		max-width: 100%;
		padding-bottom: 2px;
		scrollbar-width: none;
	}

	.watchingToolbar .sortControls::-webkit-scrollbar { display: none; }
	.watchingToolbar .sortControls > * { flex: 0 0 auto; }

	.librarySearchWrap {
		width: 100%;
		margin-top: 8px;
	}

	.librarySearchInput {
		flex: 0 1 190px;
		width: 190px;
		max-width: 190px;
	}

	.librarySearchInput:focus {
		width: 190px;
	}

	.librarySearchWrap .genreDropdown { flex: 0 0 132px; width: 132px; }
}

.librarySearchClear {
	position: absolute;
	right: 10px;
	background: none;
	border: none;
	color: var(--text);
	cursor: pointer;
	padding: 2px;
	font-size: 0.8rem;
	top: 50%;
	transform: translateY(-50%);
}

.sortControls {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.librarySearchIconButton {
	width: 36px;
	height: 36px;
	padding: 0;
	border: 1px solid var(--border);
	border-radius: 50%;
	background: transparent;
	color: var(--text-h);
	font-size: 22px;
	cursor: pointer;
}

.watchingToolbar .sortControls,
.watchingToolbar .genreDropdown {
	position: relative;
	z-index: 30;
}

.sortButton {
	border: 1px solid var(--border);
	border-radius: 999px;
	padding: 10px 16px;
	background: transparent;
	color: var(--text-h);
	cursor: pointer;
	transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.sortButton:hover {
	transform: translateY(-1px);
	box-shadow: var(--shadow);
}

.sortButtonActive {
	background: var(--accent);
	color: white;
	border-color: var(--accent);
}

/* Filter tooltip — shown on long-press of a filter button */
.filterTooltip {
	position: absolute;
	bottom: calc(100% + 8px);
	left: 50%;
	transform: translateX(-50%);
	background: var(--bg);
	color: var(--text-h);
	border: 1px solid var(--border);
	border-radius: 10px;
	padding: 8px 12px;
	font-size: 0.82rem;
	line-height: 1.4;
	white-space: normal;
	width: max-content;
	max-width: 220px;
	box-shadow: var(--shadow);
	z-index: 200;
	cursor: pointer;
	animation: modalFadeIn 0.15s ease-out;
}

/* Arrow pointing down */
.filterTooltip::after {
	content: '';
	position: absolute;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	border: 6px solid transparent;
	border-top-color: var(--border);
}

/* Force grid children to stretch so cards match heights */
.showGrid .showCardButton {
	height: 100%;
	display: block
}

.showGrid .showCardButton>.showCard {
	height: 100%
}

/* Search results use portrait artwork, so keep the full poster visible. */
.searchResults .showCardImageWrap {
	aspect-ratio: 2 / 3;
	max-height: 180px;
}

.searchResults .showCardImage,
.unwatchedGrid .showCardImage {
	object-fit: cover;
}

.showCard {
	display: flex;
	flex-direction: column;
	gap: 10px;
	transition: all 0.18s ease;
	min-height: 160px;
}

.showCardCompact {
	min-height: auto;
	gap: 6px;
	padding: 6px;
	align-items: center;
	text-align: center;
}

.showCardCompact .showCardBody {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	padding: 0;
}

.showCardCompact .showCardTitle {
	font-size: 0.95rem;
	line-height: 1.2;
}

.showCardImageWrap {
	width: 100%;
	aspect-ratio: 4/3;
	border-radius: 12px;
	overflow: hidden;
	background: var(--code-bg);
	display: flex;
	align-items: center;
	justify-content: center;
}


.showCardImageWrapCompact {
	width: 100%;
	aspect-ratio: 3/4;
	border-radius: 12px;
	overflow: hidden;
	background: var(--code-bg);
	display: flex;
	align-items: center;
	justify-content: center;
}

.showCardBodyCompact {
	padding: 0;
}

.showCardCompact .showCardTitle {
	font-size: 0.95rem;
	line-height: 1.2;
}

.showCardCompact .showCardNetwork,
.showCardCompact .showCardMeta {
	display: none;
}

/* Ensure card buttons fill grid cells and avoid overlap */
.showCardButton {
	width: 100%;
	box-sizing: border-box;
	display: block;
	text-align: left;
	text-decoration: none;
	color: inherit;
}

.showCardImage {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.showCardHeader {
	display: block;
}

.showCardHeader span,
.showCardMeta span {
	font-size: 14px;
	color: var(--text);
}

.showCardBody {
	display: flex;
	flex-direction: column;
	gap: 6px;
	flex: 1;
}

.searchResults .showCardBody {
	min-height: 0;
	gap: 3px;
}

.showCardTitle {
	font-size: 0.98rem
}

.showCardNetwork {
	font-size: 0.85rem;
	color: var(--text)
}

.timelineCard {
	display: grid;
	gap: 10px;
	grid-template-columns: 1fr;
	align-items: flex-start;
}

.timelineDate {
	font-weight: 700;
	color: var(--accent);
}

.wideCard {
	grid-column: auto;
}

.emptyState {
	padding: 36px 22px;
	text-align: center;
	color: var(--text);
	background: var(--code-bg);
	border-radius: 20px;
}

@media (min-width: 860px) {
	.headerActions {
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}

	.tabBar {
		display: flex;
		flex-wrap: wrap;
	}

	.showListItem {
		display: flex;
		justify-content: space-between;
		gap: 20px;
		align-items: center;
	}

	.showMeta,
	.showCardMeta {
		text-align: right;
		min-width: 140px;
	}

	.showCardHeader {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.timelineCard {
		grid-template-columns: 110px minmax(0, 1fr);
		align-items: center;
	}

	.settingsHeader {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.wideCard {
		grid-column: span 2;
	}
}

/* Detail View */
.detailPanel {
	margin-top: 14px;
}

.detailHeader {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 10px;
	align-items: stretch;
}

.detailHeaderActions {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
}

.detailHeaderActions > div {
	min-width: 0;
}


.detailHeaderMain {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;
}

.detailThumbnail {
	width: 90px;
	height: 135px;
	flex-shrink: 0;
	border-radius: 10px;
	overflow: hidden;
	background: var(--code-bg);
}

.detailThumbnail img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.stickyDetailHeader {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	width: min(100%, 1126px);
	padding: 10px 16px;
	background: var(--bg);
	border-bottom: 1px solid var(--border);
	box-shadow: var(--shadow);
	z-index: 500;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	box-sizing: border-box;
	cursor: pointer;
	animation: modalFadeIn 0.2s ease-out;
}

.stickyTitle {
	font-weight: 700;
	color: var(--text-h);
	font-size: 1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.stickyScrollHint {
	font-size: 0.8rem;
	color: var(--accent);
	font-weight: 600;
	white-space: nowrap;
}

.detailHeaderInfo {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
	text-align: left;
}

.nextUserEpisodeBanner {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	background: var(--accent-bg);
	border: 1px solid var(--accent-border);
	border-radius: 12px;
	margin-top: 4px;
	flex-wrap: wrap;
}

.detailHeader h2 {
	margin: 0;
}

.showMeta {
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
	font-size: 0.95em;
	color: var(--text);
}

.showDescription {
	margin: 0 0 10px;
	line-height: 1.6;
}

.seasonsContainer {
	display: grid;
	gap: 24px;
}

.seasonSection {
	border-top: 2px solid var(--border);
	padding-top: 20px;
}

.seasonSection h3 {
	margin: 0 0 16px;
	color: var(--text-h);
}

.episodeGrid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
	gap: 12px;
}

.episodeButton {
	padding: 16px;
	background: var(--code-bg);
	border: 2px solid var(--border);
	border-radius: 12px;
	cursor: pointer;
	user-select: none;
	-webkit-user-select: none;
	-webkit-touch-callout: none;
	min-height: 48px;
	text-align: center;
	transition: all 0.2s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
}

.episodeButton:focus {
	border-color: var(--accent);
	background: var(--accent-bg);
	transform: translateY(-2px);
}

.episodeButton.episodeWatched {
	background: var(--accent-bg);
	border-color: var(--accent);
	font-weight: 600;
}

/* Episode button when the show isn't followed – visually dimmed, non-interactive */
.episodeButton.episodeDisabled {
	opacity: 0.45;
	cursor: not-allowed;
	pointer-events: none;
}

.episodeNumber {
	font-weight: 700;
	color: var(--accent);
	font-size: 0.9em;
}

.episodeTitle {
	display: block;
	font-size: 0.85em;
	word-break: break-word;
	color: var(--text);
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 2.4em;
	line-height: 1.2;
}

.episodeAirDate {
	font-size: 0.7rem;
	color: var(--text);
	opacity: 0.75;
}

.badge {
	margin-top: 5px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 5px 10px;
	border-radius: 999px;
	font-weight: 700;
	line-height: 1;
	white-space: nowrap;
	width: 70px;
}

.badgeNext {
	background: var(--accent-bg);
	color: var(--accent);
	border: 1px solid var(--accent-border);
}

.badgeCountdown {
	background: rgba(255, 160, 0, 0.12);
	color: #d97706;
	border: 1px solid rgba(255, 160, 0, 0.35);
}

@media (prefers-color-scheme: dark) {
	.badgeCountdown {
		color: #fbbf24;
		background: rgba(251, 191, 36, 0.12);
		border-color: rgba(251, 191, 36, 0.3);
	}
}

/* Clickable Show Cards */
.showCardButton {
	all: unset;
	display: block;
	cursor: pointer;
	width: 100%;
}

.showCardButton:hover .showCard {
	border-color: var(--accent);
	box-shadow: var(--shadow);
	transform: translateY(-2px);
}

/* Clickable List Items */
.showListButton {
	all: unset;
	display: flex;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	background: transparent;
	border: 1px solid var(--border);
	cursor: pointer;
	gap: 16px;
	align-items: flex-start;
	transition: all 0.2s ease;
	font-size: inherit;
	color: inherit;
}

.showListButton:hover {
	border-color: var(--accent);
	box-shadow: var(--shadow);
	transform: translateY(-1px);
	background: var(--accent-bg);
}

.showListButton>div {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.showListButton h3 {
	margin: 0;
}

.showListButton p {
	margin: 0;
	font-size: 0.95em;
	color: var(--text);
}

.timelineImageWrap {
	width: 110px;
	height: 154px;
	flex: 0 0 110px;
	border-radius: 8px;
	overflow: hidden;
	background: var(--code-bg);
	display: flex;
	align-items: center;
	justify-content: center;
}

.timelineImage {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* Limit the max height of posters inside tab panes for better layout */
.showListImageWrap,
.timelineImageWrap,
.showCardImageWrap {
	max-height: 180px;
}

/* Small poster for list items */
.showListImageWrap {
	width: 96px;
	height: 144px;
	flex: 0 0 96px;
	border-radius: 8px;
	overflow: hidden;
	background: var(--code-bg);
	display: flex;
	align-items: center;
	justify-content: center;
}

.showListImage {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

/* Prevent long titles from overflowing or overlapping */
.showListButton h3,
.timelineCard h3,
.showCardTitle {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
}

/* Clickable Timeline Cards */
.timelineCardButton {
	all: unset;
	display: block;
	cursor: pointer;
	width: 100%;
}

.timelineCardButton:hover .timelineCard {
	border-color: var(--accent);
	box-shadow: var(--shadow);
	transform: translateY(-2px);
}

.timelineCard {
	transition: all 0.2s ease;
	border: 1px solid var(--border);
}

/* Upcoming timeline */
.upcomingList {
	list-style: none;
	padding: 0;
	margin: 0;
	display: grid;
	gap: 10px;
}

/* Responsive card grid for upcoming page */
.upcomingGrid {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

@media (max-width: 520px) {
	.upcomingGrid {
		grid-template-columns: 1fr;
	}
}

.calendarContainer {
	display: flex;
	flex-direction: column;
	gap: 20px;
	text-align: left;
}

.calendarDateGroup {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.calendarDateHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	background: var(--code-bg);
	border-left: 4px solid var(--accent);
	border-radius: 8px;
	font-weight: 700;
	font-size: 0.95rem;
	color: var(--text-h);
}

.calendarCountBadge {
	font-size: 0.78rem;
	font-weight: 600;
	color: var(--accent);
	background: var(--accent-bg);
	padding: 2px 8px;
	border-radius: 999px;
}

.upcomingCard {
	all: unset;
	display: flex;
	align-items: stretch;
	gap: 12px;
	width: 100%;
	box-sizing: border-box;
	min-width: 0;
	padding: 0;
	border-radius: 16px;
	border: 1px solid var(--border);
	background: var(--code-bg);
	color: inherit;
	text-decoration: none;
	cursor: pointer;
	transition: all 0.18s ease;
}

.upcomingCard:hover {
	border-color: var(--accent);
	box-shadow: var(--shadow);
	transform: translateY(-1px);
}

.upcomingCardPoster {
	width: 76px;
	height: auto;
	flex-shrink: 0;
	border-radius: 16px 0 0 16px;
	overflow: hidden;
	background: var(--border);
}

.upcomingCardPoster .showCardImage {
	width: 100%;
	height: 100%;
	max-height: none;
	object-fit: cover;
}

.upcomingCardInfo {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 3px;
	min-width: 0;
	text-align: left;
	font-size: 0.9rem;
	overflow: hidden;
	min-width: 0;
	padding: 8px 0;
}

.upcomingCardInfo > span {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
	max-width: 100%;
	line-height: 1.3;
	padding-bottom: 2px;
}

.upcomingItemButton {
	all: unset;
	display: flex;
	align-items: center;
	gap: 14px;
	width: 90%;
	box-sizing: border-box;
	padding: 12px 14px;
	border-radius: 16px;
	border: 1px solid var(--border);
	background: var(--code-bg);
	cursor: pointer;
	transition: all 0.18s ease;
}

.upcomingItemButton:hover {
	border-color: var(--accent);
	box-shadow: var(--shadow);
	transform: translateY(-1px);
}

.upcomingPoster {
	width: 90px;
	height: 130px;
	flex-shrink: 0;
	border-radius: 8px;
	overflow: hidden;
	background: var(--border);
}

.ghostButton {
	background-color: #1a191a;
	color: #696869;
	border: 1px solid transparent;
	border-radius: 999px;
	cursor: pointer;
	font: inherit;
}

.upcomingPosterPlaceholder {
	width: 100%;
	height: 100%;
	background: var(--border);
}

.upcomingInfo {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	text-align: left;
}

.upcomingTitle {
	font-size: 1rem;
	color: var(--text-h);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.upcomingNetwork {
	font-size: 0.82rem;
	color: var(--text);
}

.upcomingCountdown {
	flex-shrink: 0;
	max-width: 30%;
	padding: 0 10px 0 0;
	align-self: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 0.95rem;
	font-weight: 700;
	color: #d97706;
	text-align: right;
	white-space: nowrap;
}

.upcomingCountdownToday {
	color: #ba7bd7;
}

@media (prefers-color-scheme: dark) {
	.upcomingCountdown {
		color: #ba7bd7;
	}

	.upcomingCountdownToday {
		color: #ba7bd7;
	}
}

@media (min-width: 860px) {
	.detailHeader {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.episodeGrid {
		grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
	}
}

/* Modal Styles */
.modalOverlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.7);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	padding: 20px;
	backdrop-filter: blur(4px);
}

.modalContent {
	background: var(--bg);
	border: 1px solid var(--border);
	padding: 24px;
	border-radius: 20px;
	max-width: 500px;
	width: 100%;
	box-shadow: var(--shadow);
	animation: modalFadeIn 0.25s ease-out;
	color: var(--text-h);
}

.modalEpisodeMeta {
	font-size: 0.9rem;
	color: var(--text);
	margin: 4px 0 16px 0;
}

.modalDescription {
	line-height: 1.6;
	margin-bottom: 20px;
	max-height: 300px;
	overflow-y: auto;
}

@keyframes modalFadeIn {
	from {
		opacity: 0;
		transform: scale(0.95);
	}

	to {
		opacity: 1;
		transform: scale(1);
	}
}


/* The clear action belongs to the text field, not the adjacent genre select. */
.librarySearchWrap .librarySearchClear {
	right: 156px;
}

@media (max-width: 600px) {
	.watchingToolbar {
		display: block;
		align-items: stretch;
		min-width: 0;
		max-width: 100%;
	}

	.watchingToolbar .sortControls {
		display: flex;
		flex-wrap: nowrap;
		overflow-x: auto;
		min-width: 0;
		max-width: 100%;
		padding-bottom: 2px;
		scrollbar-width: none;
	}

	.watchingToolbar .sortControls::-webkit-scrollbar { display: none; }
	.watchingToolbar .sortControls > * { flex: 0 0 auto; }
	.watchingToolbar:not(.myShowsToolbar) .sortControls {
		overflow: visible;
	}
	.watchingToolbar .genreMenu {
		left: auto;
		right: 0;
	}

	.myShowsToolbar .sortControls {
		flex-wrap: wrap;
		overflow: visible;
	}

	.myShowsToolbar .sortControls .sortButton {
		padding: 7px 10px;
		font-size: 0.78rem;
	}

	.myShowsToolbar .librarySearchIconButton {
		width: 32px;
		height: 32px;
		font-size: 19px;
	}

	.myShowsToolbar .sortControls .genreDropdown,
	.myShowsToolbar .sortControls .genreDropdown .genreButton {
		flex-basis: 90px;
		width: 90px !important;
		min-width: 90px !important;
		max-width: 90px !important;
	}

	.myShowsToolbar .sortControls .genreDropdown .genreButton {
		padding-left: 7px !important;
		padding-right: 7px !important;
	}

	/* My Shows: put All beside Completed, then keep search + genre on row two. */
	.myShowsToolbar .sortControls > :nth-child(6) { order: 4; }
	.myShowsToolbar .sortControls > :nth-child(4) { order: 5; }
	.myShowsToolbar .sortControls > :nth-child(5) { order: 6; }
	.myShowsToolbar .sortControls > :nth-child(7) { order: 7; }
	.myShowsToolbar .sortControls > :nth-child(8) { order: 8; }

	.watchingToolbar .sortControls {
		display: flex;
		align-items: center;
		width: 100%;
	}

	.watchingToolbar .sortControls .genreDropdown {
		flex: 0 0 104px;
		width: 104px;
		max-width: 104px;
	}

	.watchingToolbar .sortControls .genreDropdown .genreButton {
		width: 104px !important;
		min-width: 104px !important;
		max-width: 104px !important;
		padding-left: 9px !important;
		padding-right: 9px !important;
	}

	.watchingToolbar .sortControls::-webkit-scrollbar { display: none; }
	.watchingToolbar .sortControls .sortButton { padding: 8px 12px; font-size: 0.86rem; white-space: nowrap; }

	.watchingToolbar .sortControls > * { flex: 0 0 auto; }
}
.searchInputWrap .librarySearchClear { right: 10px; }
